import get from "lodash/get";
import sortBy from "lodash/sortBy";

export default {
  getLiveCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/categoryresource?id=21&level=0")
        .then(response => {
          const categories = get(response, "data.results[0].children", []);
          const sortedCategories = sortBy(categories, "order");
          sortedCategories.forEach(category => {
            if (category.children && category.children.length > 0) {
              category.children = sortBy(category.children, "order");
            }
          });
          context.commit("setLiveCategories", sortedCategories);
          resolve();
        })
        .catch(reject);
    });
  },
  getLives(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/resources?category=lives&category_resource=${id}&limit=1000`
        )
        .then(response => {
          context.commit("setLives", {
            id,
            lives: response.data.results
          });
          resolve();
        })
        .catch(reject);
    });
  },
  getLive(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/lives")
        .then(response => {
          context.commit("setLive", response.data);
          resolve();
        })
        .catch(reject);
    });
  }
};
